module.exports = __webpack_public_path__ + "static/media/BANANA-XRP-BNB.106cce81.svg";